<template>
  <pt-insure-info @exportInsureMaterials="exportInsureMaterials" :exportLoading="exportLoading" class="pt-insure-info__withData"></pt-insure-info>
</template>

<script>
import PtInsureInfo from './index'
export default {
  name: 'pt-insure-info__withData',
  components: {
    'pt-insure-info': PtInsureInfo
  },
  data () {
    return {
      exportLoading: false
    }
  },
  methods: {
    // 导出投保信息列表
    exportInsureMaterials (val) {
      this.exportLoading = true
      this.$store.dispatch('exportInsureMaterials', val).then(res => {
        this.exportLoading = false
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出订金结算失败')
      })
    }
  }
}
</script>
